module.exports = __webpack_public_path__ + "static/media/top_pausebutton.123232a2.jpg";